import React from "react";
import { useNavigate } from "react-router-dom";

const InvalidAccess = () => {
  const navigate = useNavigate();

  return (
    <div className="justify-content-center d-flex align-content-center vh-100 justify-content-center">
      <div className="text-center">
        <div className=" mb-4 text-center mt-5"><span style={{fontSize:'40px'}}>🚫</span></div>
        <h1 className="font-bold font-24 text-danger mb-2">Access Denied</h1>
        <p className="text-seondary font-20 mb-4">
          You do not have permission to access this page.
        </p>
       
      </div>
    </div>
  );
};

export default InvalidAccess;
